/**
 * MESAJLAŞMA SÖZLEŞMESİ — F-MSG
 *
 * ================================================================
 * GERİ ALMA PENCERESİ NEDEN SÖZLEŞMEDE
 * ================================================================
 * Sunucu bu süreye göre reddediyor; arayüz aynı süreye göre "Geri al"
 * düğmesini gösteriyor. İkisi ayrı yerde yazılsaydı ayrıştıkları gün
 * **iki yönde de** bozulurdu: görünen ama basınca hata veren bir düğme
 * (kullanıcı sistemin bozuk olduğunu düşünür), ya da hâlâ geri
 * alınabilecekken kaybolan bir düğme (kullanıcı hakkını kaybeder).
 *
 * Bu depoda tam olarak bu hata ölçüldü — panel kendi
 * `GEREKCE_EN_AZ = 15`ini tanımlayıp sözleşmedeki 3'ü gölgelemişti ve
 * bağımsız bir denetim yarım saatini buna kaybetti (`golgeleme.test.ts`).
 */

/**
 * Geri alma penceresi — dakika (F-MSG-01b).
 *
 * Emre "kısa bir süre" dedi; sayı ölçülebilir olmalı ve tek yerde
 * durmalı. İki dakika: yanlış kişiye gönderdiğini fark etmeye yeter,
 * karşı tarafın okumasını bekleyip sonra "hiç yazmadım" demeye yetmez.
 *
 * ⚠️ SÜRE TEK BAŞINA YETMİYOR: okunmuş bir mesaj süre dolmamış olsa
 * bile geri alınamaz. Arayüz bu düğmeyi göstermeye karar verirken
 * süreye bakabilir ama son sözü **sunucu** söyler.
 */
export const GERI_ALMA_DAKIKA = 2;

/** Mesaj gövdesinin üst sınırı — sunucu da bunu doğruluyor. */
export const MESAJ_EN_COK = 5000;

/**
 * HAZIR MESAJ ŞABLONU — F-MSG-04.
 *
 * ================================================================
 * ŞABLON KİŞİSEL, KURUM GENELİ DEĞİL
 * ================================================================
 * Şartnamenin cümlesi: *"Hazır mesaj şablonları (uzman için sık
 * kullanılan yanıtlar)."* Sahibi bir kullanıcı.
 *
 * Kurum geneli ortak şablon bilerek yazılmadı: ayrı bir izin yüzeyi
 * açar ve "bu şablonu kim değiştirebilir" sorusunu doğurur. İleride
 * gerekirse eklenir; bugün yazılmayan bir yetkiyi şimdiden açmak,
 * geri alması en zor karardır.
 */

/** Başlık, listede seçilebilecek kadar kısa olmalı. */
export const SABLON_BASLIK_EN_COK = 60;

/**
 * Şablon gövdesi mesaj sınırıyla AYNI.
 *
 * Ayrı bir sayı yazsaydık, gönderilemeyen bir şablon üretmek mümkün
 * olurdu: kullanıcı şablonu kaydeder, eklediğinde mesaj reddedilirdi
 * ve hata şablonu değil mesajı işaret ederdi.
 */
export const SABLON_GOVDE_EN_COK = MESAJ_EN_COK;

/** Kişi başına şablon sayısı — seçim listesi okunabilir kalsın. */
export const SABLON_EN_COK_ADET = 30;
